;(function () {
  // Shared selection logic (storage key, model map, parse, label) is defined
  // inline (non-deferred) in header-fit-vehicle.liquid, so window.RivianFitVehicle
  // exists before this deferred script runs.
  const store = window.RivianFitVehicle
  const FIT_VEHICLE_STORAGE_KEY = store
    ? store.STORAGE_KEY
    : "fit_vehicle_selection"
  const MODEL_DISPLAY_NAMES = store
    ? store.MODEL_DISPLAY_NAMES
    : Object.freeze({
        r1t: "R1T",
        r1s: "R1S",
        r2: "R2",
        edv: "EDV",
        rcv: "RCV",
      })
  const VIN_REGEX = /^[A-HJ-NPR-Z0-9]{17}$/
  const VEHICLE_MODEL_PARAM = "filter.v.m.custom.vehicle_model"
  const VEHICLE_YEAR_PARAM = "filter.v.m.custom.vehicle_year"

  const isCollectionPage = () =>
    !!document.querySelector("[data-vehicle-collection-url]")

  const redirectToAllCollections = (model, year) => {
    const wrapper = document.querySelector("[data-all-collections-url]")
    if (!wrapper) return

    const baseUrl = wrapper.getAttribute("data-all-collections-url")
    const params = new URLSearchParams()
    const displayName = model
      ? MODEL_DISPLAY_NAMES[model.toLowerCase()] || model
      : null

    const fitment = window.RivianVehicleFitment
    if (fitment) {
      fitment.applyParams(params, displayName, year)
    } else {
      if (displayName) params.append(VEHICLE_MODEL_PARAM, displayName)
      if (year) params.append(VEHICLE_YEAR_PARAM, year)
    }

    const qs = params.toString()
    window.location.href = baseUrl + (qs ? "?" + qs : "")
  }

  // Hide/disable year options that aren't valid for the selected model, and
  // clear a selected year that's no longer valid. No model selected, or no
  // configured constraint, leaves all years available.
  const applyYearConstraints = (form) => {
    const modelSelect = form.querySelector('[name="model"]')
    const yearSelect = form.querySelector('[name="year"]')
    if (!modelSelect || !yearSelect) return

    const fitment = window.RivianVehicleFitment
    const validYears =
      fitment && modelSelect.value
        ? fitment.validYearsFor(modelSelect.value)
        : null

    let clearedSelected = false
    Array.from(yearSelect.options).forEach((option) => {
      if (option.value === "") return
      const allowed = !validYears || validYears.indexOf(option.value) !== -1
      option.hidden = !allowed
      option.disabled = !allowed
      if (!allowed && option.selected) clearedSelected = true
    })

    if (clearedSelected) yearSelect.value = ""
  }

  const saveFitVehicleSelection = (payload) => {
    try {
      const persistedPayload = {
        ...payload,
        vin: null,
      }

      window.localStorage.setItem(
        FIT_VEHICLE_STORAGE_KEY,
        JSON.stringify(persistedPayload)
      )
    } catch (error) {
      console.warn("Unable to persist fit vehicle selection", error)
    }
  }

  const loadFitVehicleSelection = () => {
    if (store) return store.getSelection()
    if (!window.localStorage) return null

    try {
      const rawPayload = window.localStorage.getItem(FIT_VEHICLE_STORAGE_KEY)
      if (!rawPayload) return null

      const payload = JSON.parse(rawPayload)
      if (!payload || typeof payload !== "object") return null

      return payload
    } catch (error) {
      console.warn("Unable to read fit vehicle selection", error)
      return null
    }
  }

  const updateHeaderTriggerLabel = () => {
    if (store) {
      store.applyTriggerLabels()
      return
    }

    const payload = loadFitVehicleSelection()
    const triggers = document.querySelectorAll(
      ".header-fit-vehicle__trigger-label"
    )
    if (triggers.length === 0) return

    const model =
      payload && typeof payload.model === "string"
        ? MODEL_DISPLAY_NAMES[payload.model.toLowerCase()] || null
        : null
    const year =
      payload &&
      typeof payload.year === "string" &&
      /^\d{4}$/.test(payload.year)
        ? payload.year
        : null

    const parts = []
    if (model) parts.push(model)
    if (year) parts.push(year)
    const label = parts.length > 0 ? parts.join(" ") : null

    for (const trigger of triggers) {
      const text = label || trigger.getAttribute("data-default-label")
      if (text) trigger.textContent = text
    }
  }
  const updateClearButtonVisibility = (form) => {
    const clearButton = form.querySelector("[data-fit-vehicle-clear]")
    if (!clearButton) return

    const hasSavedSelection = !!loadFitVehicleSelection()
    clearButton.hidden = !hasSavedSelection
  }
  const clearFitVehicleSelection = (form) => {
    try {
      window.localStorage.removeItem(FIT_VEHICLE_STORAGE_KEY)
    } catch {
      /* ignore */
    }

    const modeInput = form.querySelector(
      'input[name="fit_vehicle_mode"][value="model_year"]'
    )
    if (modeInput) modeInput.checked = true

    const modelSelect = form.querySelector('[name="model"]')
    if (modelSelect) modelSelect.value = ""

    const yearSelect = form.querySelector('[name="year"]')
    if (yearSelect) yearSelect.value = ""

    const vinInput = form.querySelector('[name="vin"]')
    if (vinInput) {
      vinInput.value = ""
      vinInput.setCustomValidity("")
    }

    syncPanels(form)
    updateHeaderTriggerLabel()
    updateClearButtonVisibility(form)

    window.dispatchEvent(
      new CustomEvent("fit-vehicle:changed", {
        detail: { model: null, year: null },
      })
    )

    closeFitVehicleModal(form)
  }
  const normalizeVin = (value) => {
    return (value || "").toUpperCase().replace(/\s+/g, "").trim()
  }

  const validateVinInput = (vinInput) => {
    if (!vinInput) return false

    const normalizedVin = normalizeVin(vinInput.value)
    vinInput.value = normalizedVin

    if (!normalizedVin) {
      vinInput.setCustomValidity("Enter a VIN.")
      return false
    }

    if (!VIN_REGEX.test(normalizedVin)) {
      vinInput.setCustomValidity("Enter a valid 17-character VIN.")
      return false
    }

    vinInput.setCustomValidity("")
    return true
  }

  const hydrateFitVehicleForm = (form) => {
    const payload = loadFitVehicleSelection()
    if (!payload) return

    const mode = payload.mode === "vin" ? "vin" : "model_year"
    const modeInput = form.querySelector(
      `input[name="fit_vehicle_mode"][value="${mode}"]`
    )
    if (modeInput) {
      modeInput.checked = true
    }

    const modelSelect = form.querySelector('[name="model"]')
    const yearSelect = form.querySelector('[name="year"]')
    const vinInput = form.querySelector('[name="vin"]')

    if (modelSelect && typeof payload.model === "string") {
      const hasModelOption = Array.from(modelSelect.options).some(
        (option) => option.value === payload.model
      )
      if (hasModelOption) {
        modelSelect.value = payload.model
      }
    }

    if (yearSelect && typeof payload.year === "string") {
      const hasYearOption = Array.from(yearSelect.options).some(
        (option) => option.value === payload.year
      )
      if (hasYearOption) {
        yearSelect.value = payload.year
      }
    }
  }

  const closeFitVehicleModal = (form) => {
    const modal = form.closest("modal-dialog")
    if (!modal || typeof modal.hide !== "function") return

    modal.hide()
  }

  const syncPanels = (form) => {
    const mode = form.querySelector(
      'input[name="fit_vehicle_mode"]:checked'
    )?.value
    const panels = form.querySelectorAll("[data-fit-vehicle-panel]")
    const vinInput = form.querySelector('[name="vin"]')

    for (const panel of panels) {
      const active = panel.getAttribute("data-fit-vehicle-panel") === mode
      panel.toggleAttribute("inert", !active)
      panel.setAttribute("aria-hidden", active ? "false" : "true")
    }

    if (mode === "model_year" && vinInput) {
      vinInput.value = ""
      vinInput.setCustomValidity("")
    }
  }

  const initFitVehicleModal = () => {
    const form = document.querySelector("[data-fit-vehicle-form]")
    if (!form) return

    hydrateFitVehicleForm(form)
    syncPanels(form)
    applyYearConstraints(form)
    updateHeaderTriggerLabel()
    updateClearButtonVisibility(form)

    form.querySelectorAll('input[name="fit_vehicle_mode"]').forEach((radio) => {
      radio.addEventListener("change", () => {
        syncPanels(form)
      })
    })

    const modelSelectEl = form.querySelector('[name="model"]')
    if (modelSelectEl) {
      modelSelectEl.addEventListener("change", () => applyYearConstraints(form))
    }

    const clearButton = form.querySelector("[data-fit-vehicle-clear]")
    if (clearButton) {
      clearButton.addEventListener("click", () => {
        clearFitVehicleSelection(form)
      })
    }

    form.addEventListener("submit", (event) => {
      event.preventDefault()

      const mode = form.querySelector(
        'input[name="fit_vehicle_mode"]:checked'
      )?.value
      const modelSelect = form.querySelector('[name="model"]')
      const yearSelect = form.querySelector('[name="year"]')
      const vinInput = form.querySelector('[name="vin"]')

      const payload =
        mode === "vin"
          ? {
              mode: "vin",
              model: null,
              year: null,
              vin: vinInput ? normalizeVin(vinInput.value) : "",
            }
          : {
              mode: "model_year",
              model: modelSelect ? modelSelect.value : "",
              year: yearSelect ? yearSelect.value : "",
              vin: null,
            }

      if (mode === "vin") {
        const isVinValid = validateVinInput(vinInput)
        if (!isVinValid) {
          vinInput?.reportValidity()
          return
        }

        const decodeResult = window.RivianVinDecoder?.decodeVin(payload.vin)

        if (!decodeResult || !decodeResult.ok) {
          const errorMessage =
            decodeResult?.error?.message || "Unable to decode VIN."
          vinInput.setCustomValidity(errorMessage)
          vinInput.reportValidity()
          return
        }

        payload.decoded = {
          model: decodeResult.value.model,
          year: decodeResult.value.year,
        }

        const decodedModelValue =
          decodeResult.value.model.modelKey.toLowerCase()
        const decodedYearValue = String(decodeResult.value.year.modelYear)

        payload.model = decodedModelValue
        payload.year = decodedYearValue

        if (modelSelect) {
          const hasModelOption = Array.from(modelSelect.options).some(
            (option) => option.value === decodedModelValue
          )
          if (hasModelOption) {
            modelSelect.value = decodedModelValue
          }
        }

        if (yearSelect) {
          const hasYearOption = Array.from(yearSelect.options).some(
            (option) => option.value === decodedYearValue
          )
          if (hasYearOption) {
            yearSelect.value = decodedYearValue
          }
        }

        // Setting selects programmatically doesn't fire "change", so refresh
        // the year-option constraints for the decoded model.
        applyYearConstraints(form)
      }

      // Drop an invalid model+year combo (e.g. a model paired with a year it
      // isn't sold in) before applying.
      const fitment = window.RivianVehicleFitment
      if (
        payload.model &&
        payload.year &&
        fitment &&
        !fitment.isValidCombo(payload.model, payload.year)
      ) {
        payload.year = ""
        if (yearSelect) yearSelect.value = ""
      }

      const hasSelection = !!(payload.model || payload.year)

      if (hasSelection) {
        saveFitVehicleSelection(payload)
      } else {
        try {
          window.localStorage.removeItem(FIT_VEHICLE_STORAGE_KEY)
        } catch {
          /* ignore */
        }
      }

      updateHeaderTriggerLabel()
      updateClearButtonVisibility(form)

      if (hasSelection && !isCollectionPage()) {
        redirectToAllCollections(payload.model, payload.year)
        return
      }

      window.dispatchEvent(
        new CustomEvent("fit-vehicle:changed", {
          detail: { model: payload.model, year: payload.year },
        })
      )

      closeFitVehicleModal(form)
    })

    const vinInput = form.querySelector('[name="vin"]')
    if (vinInput) {
      vinInput.addEventListener("input", () => {
        if (!vinInput.value) {
          vinInput.setCustomValidity("")
          return
        }

        validateVinInput(vinInput)
      })
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFitVehicleModal)
  } else {
    initFitVehicleModal()
  }
})()
